import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: true,
    edgeService: 'https://api.dilearning.ceres.siemens.cloud',
    // AppSync Events URLs
    appSyncRealtimeUrl: 'wss://appsync.api.dilearning.ceres.siemens.cloud/event/realtime',
    appSyncHttpUrl: 'https://appsync.api.dilearning.ceres.siemens.cloud/event',
    scdUrl: 'https://api.scd.suites.siemens.cloud',
    siteCollection: '/content/10000120',
    languageAssetsPath: './assets/language/',
    tracking: true,
    whitelist: ['localhost:3000', 'api.dilearning.ceres.siemens.cloud'],
    apiKey: 'JYdsS9A5is4qaJVXbO5Tp85itCNlIJAJ4537I45f',
    tenant: 'DI CS FA DIL',
    guestAccess: false,
    links: {
        documentOfferTemplate: '',
        documentOfferTemplateEN: ''
    },
    junoApp: 'https://juno.suites.siemens.cloud',
    junoApiURI: 'https://api.mail.wcs-apps.siemens.cloud/v2.0',
    junoAppId: '73a1c4a89ae54505824b6f0f4fcc78b3',
    commentRequiredThreshold: 10,
    timeSheetSumRowFloatingPoints: '1.2-2',
    timeSheetRounding: false,
    servicesDocumentationLink: '',
    msalConfig: {
        auth: {
            clientId: '44bb4566-aa31-4e48-a9f3-3e576646ed20', // Your application's client ID from Entra ID
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a', // Your tenant ID in format https://login.microsoftonline.com/${tenantId}
            redirectUri: window.location.origin, // Where to redirect after login, this needs to match exactly the redirectUri in Azure
            postLogoutRedirectUri: window.location.origin, // Where to redirect after logout
            navigateToLoginRequestUrl: true // Navigate back to the original request URL after login, this needs to match exactly the redirectUri in Azure
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage, // Store auth data in session storage
            storeAuthStateInCookie: false // Don't use cookies for state
        },
        system: {
            allowPlatformBroker: false // Don't use platform brokers like WAM
        }
    },
    apiConfig: [
        {
            scopes: ['User.ReadBasic.All', 'User.Read'],
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: ['https://api.dilearning.ceres.siemens.cloud/App.Access.All'],
            uri: 'https://api.dilearning.ceres.siemens.cloud/'
        }
    ]
};
